exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3IzLyzM5OynHQS7QTwAftf {\n  align-items: center;\n  background: none;\n  border: none;\n  border-radius: 4px;\n  color: var(--secondary-text-color);\n  cursor: pointer;\n  display: flex;\n  padding: 4px;\n}\n\n._3IzLyzM5OynHQS7QTwAftf:hover {\n  background-color: var(--light-line-divider-color);\n}\n\n._3IzLyzM5OynHQS7QTwAftf[aria-pressed='true'] {\n  color: var(--primary-base-color);\n}\n", ""]);

// Exports
exports.locals = {
	"subscriptionToggle": "_3IzLyzM5OynHQS7QTwAftf"
};